import type { SeriesItem } from '@/types/api/dashboard'

interface StatusBadgeGroupWidgetProps {
  title: string
  data?: SeriesItem[]
}

const BADGE_COLORS = [
  { bg: 'bg-blue-100 text-blue-700 ring-blue-200/50', dot: 'bg-blue-500' },
  { bg: 'bg-emerald-100 text-emerald-700 ring-emerald-200/50', dot: 'bg-emerald-500' },
  { bg: 'bg-amber-100 text-amber-700 ring-amber-200/50', dot: 'bg-amber-500' },
  { bg: 'bg-purple-100 text-purple-700 ring-purple-200/50', dot: 'bg-purple-500' },
  { bg: 'bg-rose-100 text-rose-700 ring-rose-200/50', dot: 'bg-rose-500' },
  { bg: 'bg-cyan-100 text-cyan-700 ring-cyan-200/50', dot: 'bg-cyan-500' },
  { bg: 'bg-teal-100 text-teal-700 ring-teal-200/50', dot: 'bg-teal-500' },
  { bg: 'bg-indigo-100 text-indigo-700 ring-indigo-200/50', dot: 'bg-indigo-500' },
]

export function StatusBadgeGroupWidget({ title, data = [] }: StatusBadgeGroupWidgetProps) {
  return (
    <div className="flex h-full flex-col p-4">
      <div className="mb-4 flex items-center gap-2">
        <div className="flex h-5 w-5 items-center justify-center rounded bg-gradient-to-br from-teal-500 to-emerald-500 text-[10px] text-white font-bold">◆</div>
        <p className="text-xs font-semibold uppercase tracking-wider text-neutral-500">{title}</p>
      </div>
      {data.length === 0 ? (
        <div className="flex flex-1 items-center justify-center">
          <p className="text-sm text-neutral-400">No status data available</p>
        </div>
      ) : (
        <div className="flex flex-1 flex-wrap content-start gap-2">
          {data.map((item, index) => {
            const color = BADGE_COLORS[index % BADGE_COLORS.length]
            return (
              <span
                key={item.label}
                className={`inline-flex items-center gap-1.5 rounded-full ${color.bg} ring-1 ${color.bg.split(' ')[2]} px-3 py-1 text-xs font-semibold shadow-sm`}
              >
                <span className={`h-1.5 w-1.5 rounded-full ${color.dot}`} />
                {item.label}
                <span className="ml-0.5 font-bold">{String(item.value)}</span>
              </span>
            )
          })}
        </div>
      )}
    </div>
  )
}
